import { ChangeDetectionStrategy, Component, computed, Input, OnInit, signal, Signal } from '@angular/core';
import { Observable } from 'rxjs';
import { SystemInfo } from '@platform/platform.state';
import { CustomerSpace } from '@core/core.state';
import { select, Store } from '@ngrx/store';
import { RootState } from '@root/app.state';
import { toSignal } from '@angular/core/rxjs-interop';
import { selectNavigatedCustomerSpace } from '@core/core.selectors';
import { map } from 'rxjs/operators';
import { selectSystemInfo } from '@platform/platform.selectors';

@Component({
  selector: 'app-plain-shell',
  templateUrl: './plain-shell.component.html',
  styleUrls: ['./plain-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlainShellComponent implements OnInit {
  public systemInfo$!: Observable<SystemInfo>;

  // Navigated CustomerSpace still contains the old value when returning to overview page
  // Therefore, we only display the links if the id of the navigated CustomerSpace is equal to the id in the route
  public checkedCustomerSpace = computed<CustomerSpace | undefined>(() => {
    const customerSpace = this.navigatedCustomerSpace();
    return customerSpace?.id === this._customerSpaceId() ? customerSpace : undefined;
  });

  private readonly navigatedCustomerSpace: Signal<CustomerSpace | undefined>;
  private _customerSpaceId = signal<string | undefined>(undefined);

  constructor(private store$: Store<RootState>) {
    this.navigatedCustomerSpace = toSignal(
      this.store$.pipe(
        select(selectNavigatedCustomerSpace),
        map((resource) => (resource.status === 'SUCCEEDED' ? resource.data : undefined)),
      ),
    );
  }

  @Input({ required: true }) set customerSpaceId(value: string | undefined) {
    this._customerSpaceId.set(value);
  }

  ngOnInit(): void {
    this.systemInfo$ = this.store$.pipe(select(selectSystemInfo));
  }
}
